import { Outlet, NavLink, useLocation } from 'react-router-dom'
import { useState } from 'react'
import QuickAddModal from './QuickAddModal'

export default function Layout({ onLogout }) {
  const [showQuickAdd, setShowQuickAdd] = useState(false)
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false)
  const location = useLocation()

  const navItems = [
    { to: '/', label: 'Dashboard', icon: '🏠' },
    { to: '/expenses', label: 'Pengeluaran', icon: '💸' },
    { to: '/wishlist', label: 'Wishlist', icon: '🎁' },
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="max-w-2xl mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-2xl">💰</span>
            <h1 className="font-bold text-gray-900 text-lg">Finance Tracker</h1>
          </div>
          <button
            onClick={() => setShowLogoutConfirm(true)}
            className="text-gray-500 hover:text-red-500 transition-colors text-sm flex items-center gap-1"
          >
            <span>🚪</span>
            <span className="hidden sm:inline">Keluar</span>
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-2xl mx-auto px-4 py-6 pb-24">
        <Outlet />
      </main>

      {/* Quick Add FAB */}
      <button
        onClick={() => setShowQuickAdd(true)}
        className="fixed bottom-20 right-4 sm:right-8 w-14 h-14 bg-primary text-white rounded-full shadow-lg hover:bg-blue-700 transition-all hover:scale-110 flex items-center justify-center text-2xl z-30"
      >
        +
      </button>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40">
        <div className="max-w-2xl mx-auto px-4">
          <div className="flex justify-around">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `flex flex-col items-center py-3 px-4 text-xs transition-colors ${
                    isActive 
                      ? 'text-primary font-semibold' 
                      : 'text-gray-400 hover:text-gray-600'
                  }`
                }
              >
                <span className="text-xl mb-0.5">{item.icon}</span>
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      </nav>

      {/* Quick Add Modal */}
      {showQuickAdd && (
        <QuickAddModal onClose={() => setShowQuickAdd(false)} />
      )}

      {/* Logout Confirm Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm">
            <h3 className="font-bold text-lg mb-2">Keluar dari Aplikasi?</h3>
            <p className="text-gray-500 text-sm mb-6">Kamu perlu PIN untuk masuk kembali.</p>
            <div className="flex gap-3">
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="btn-secondary flex-1"
              >
                Batal
              </button>
              <button
                onClick={onLogout}
                className="btn-danger flex-1"
              >
                Keluar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
